import React from 'react';
import { Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import EllipsisHandler from 'components/shared/EllipsisHandler';

const File = ({ fileName, fileDownloadUrl }) => {
  return (
    <li className="PublishedVersionCollection-dataRow truncateRow h-bc-gray-lightest">
      <EllipsisHandler className="truncateRow-name" tooltipTitle={fileName}>
        {fileName}
      </EllipsisHandler>
      <Text
        variant={TEXT_VARIANTS.BODY_LINK}
        component="a"
        className="u-linkBtn PublishedVersionCollection-link truncateRow-download"
        data-testid="scorm-file-download-link"
        href={fileDownloadUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon className="mr-11" name="download" />
        {t('common.download')}
      </Text>
    </li>
  );
};

export default File;
